import * as React from 'react'
import { LogPointStates } from '../../../util/LogPointsService'
import { LogPointCategory, LogPointType } from '../../../util/LoggingPolicyConfigurations'
import { LogPointsSidebarItem } from './LogPointsSidebarItem'
import { LogPointsSidebarHeaderItem } from './LogPointsSidebarHeaderItem'
import './LogPointsSidebar.css'

export type ValueProps = {
  state: LogPointStates
  selectedType: LogPointType
  selectedCategory: LogPointCategory
}

export type EventProps = {
  onClick: (type: LogPointType, category: LogPointCategory) => void
  onToggleAll: (toggleNewVal: boolean) => void
}

export type Props = ValueProps & EventProps

const basicItemProps = (props: Props) => {
  const {state, selectedType, selectedCategory, onClick, onToggleAll} = props
  return {selectedType, selectedCategory, state, onClick, onToggleAll}
}

const requestHeaderProps = (props: Props) => {
  return {...basicItemProps(props), type: LogPointType.Request, category: LogPointCategory.Header}
}

const requestBodyProps = (props: Props) => {
  return {...basicItemProps(props), type: LogPointType.Request, category: LogPointCategory.Body}
}

const responseHeaderProps = (props: Props) => {
  return {...basicItemProps(props), type: LogPointType.Response, category: LogPointCategory.Header}
}

const responseBodyProps = (props: Props) => {
  return {...basicItemProps(props), type: LogPointType.Response, category: LogPointCategory.Body}
}

export const LogPointsSidebar = (props: Props) => (
  <div className="log-points-sidebar" data-test-id="log-points-sidebar">
    <div>
      <div className="log-points-sidebar-type-section" data-test-id="log-points-sidebar-type-section-request">
        <LogPointsSidebarHeaderItem type={LogPointType.Request} icon="forward-small" testId="request"/>
        <LogPointsSidebarItem {...requestHeaderProps(props)}/>
        <LogPointsSidebarItem {...requestBodyProps(props)}/>
      </div>

      <div>
        <div className="log-points-sidebar-type-section" data-test-id="log-points-sidebar-type-section-response">
          <LogPointsSidebarHeaderItem type={LogPointType.Response} icon="undo-small"  testId="response"/>
          <LogPointsSidebarItem {...responseHeaderProps(props)}/>
          <LogPointsSidebarItem {...responseBodyProps(props)}/>
        </div>
      </div>
    </div>
  </div>
)
